import {
    UIActionTypes,
    ChangeViewModeActionType,
    ChangeSettingsActionType,
    ChangeCollaborationActionType,
    ChangeUserOptionsActionType,
    ChangeCurrentPopupActionType,
    ChangeCurrentFieldActionType,
    ChangeSideBarActionType,
    ChangeInputEditingActionType,
    ChangeFormBackgroundActionType,
    ChangeFormBackgroundStyleVisibilityActionType,
    ChangeIsPaginationActiveRequestActionType,
    ChangeIsPaginationActiveSuccessActionType,
    ChangeIsPaginationActiveFailureActionType,
    ChangeLogicPopupActionType,
    ChangeCurrentLoginPopupStateActionType,
    ChangeMapScriptStatusActionType,
    ChangePagesViewModeSuccessActionType,
    ChangePagesViewModeFailureActionType,
    ChangePagesViewModeRequestActionType,
    InitUIActionType,
    ChangeAuthPopUpRenderActionType,
} from "./types";

import { ActionCreator } from "../types/store-types";

export const changeViewMode: ActionCreator<ChangeViewModeActionType> = payload => ({
    type: UIActionTypes.CHANGE_VIEW_MODE,
    payload,
});

export const changeSettings: ActionCreator<ChangeSettingsActionType> = payload => ({
    type: UIActionTypes.CHANGE_SETTINGS,
    payload,
});

export const changeCollaboration: ActionCreator<ChangeCollaborationActionType> = payload => ({
    type: UIActionTypes.CHANGE_COLLABORATION,
    payload,
});

export const changeUserOptions: ActionCreator<ChangeUserOptionsActionType> = payload => ({
    type: UIActionTypes.CHANGE_USER_OPTIONS,
    payload,
});

export const changeCurrentPopup: ActionCreator<ChangeCurrentPopupActionType> = payload => ({
    type: UIActionTypes.CHANGE_CURRENT_POPUP,
    payload,
});

export const changeCurrentLoginPopupState: ActionCreator<ChangeCurrentLoginPopupStateActionType> = payload => ({
    type: UIActionTypes.CHANGE_CURRENT_LOGIN_POPUP_STATE,
    payload,
});

export const changeCurrentField: ActionCreator<ChangeCurrentFieldActionType> = payload => ({
    type: UIActionTypes.CHANGE_CURRENT_FIELD,
    payload,
});

export const changeCurrentInputEditing: ActionCreator<ChangeInputEditingActionType> = payload => ({
    type: UIActionTypes.CHANGE_INPUT_EDITTING,
    payload,
});

export const changeSideBar: ActionCreator<ChangeSideBarActionType> = payload => ({
    type: UIActionTypes.CHANGE_SIDEBAR,
    payload,
});

export const changeFormBackground: ActionCreator<ChangeFormBackgroundActionType> = payload => ({
    type: UIActionTypes.CHANGE_FORM_BACKGROUND,
    payload,
});

export const changeFormBackgroundStyleVisibility: ActionCreator<
    ChangeFormBackgroundStyleVisibilityActionType
> = payload => ({
    type: UIActionTypes.CHANGE_FORM_BACKGROUND_VISIBILITY,
    payload,
});

export const changePaginationActiveStatusRequest: ActionCreator<
    ChangeIsPaginationActiveRequestActionType
> = payload => ({
    type: UIActionTypes.CHANGE_PAGINATION_ACTIVE_STATUS_REQUEST,
    payload,
});

export const changePaginationActiveStatusSuccess: ActionCreator<
    ChangeIsPaginationActiveSuccessActionType
> = payload => ({
    type: UIActionTypes.CHANGE_PAGINATION_ACTIVE_STATUS_SUCCESS,
    payload,
});

export const changePaginationActiveStatusFailure: ActionCreator<
    ChangeIsPaginationActiveFailureActionType
> = payload => ({
    type: UIActionTypes.CHANGE_PAGINATION_ACTIVE_STATUS_FAILURE,
    payload,
});

export const changeLogicPopup: ActionCreator<ChangeLogicPopupActionType> = payload => ({
    type: UIActionTypes.CHANGE_LOGIC_POPUP,
    payload,
});

export const changeIsVerticalViewRequest: ActionCreator<ChangePagesViewModeRequestActionType> = payload => ({
    type: UIActionTypes.CHANGE_PAGE_VIEW_MODE_REQUEST,
    payload,
});

export const changeIsVerticalViewSuccsess: ActionCreator<ChangePagesViewModeSuccessActionType> = payload => ({
    type: UIActionTypes.CHANGE_PAGE_VIEW_MODE_SUCCESS,
    payload,
});

export const changeIsVerticalViewFailure: ActionCreator<ChangePagesViewModeFailureActionType> = payload => ({
    type: UIActionTypes.CHANGE_PAGE_VIEW_MODE_FAILURE,
    payload,
});

export const initUI: ActionCreator<InitUIActionType> = payload => ({
    type: UIActionTypes.INIT_UI,
    payload,
});

export const changeMapScriptStatus: ActionCreator<ChangeMapScriptStatusActionType> = payload => ({
    type: UIActionTypes.CHANGE_MAP_SCRIPT_STATUS,
    payload,
});

export const changeAuthPopUpRender: ActionCreator<ChangeAuthPopUpRenderActionType> = payload => ({
    type: UIActionTypes.CHANGE_AUTH_POPUP,
    payload,
});
